<template>
  <div>
    <bs-card class="card-info" :label="$tc('labels.budget', 1)" style="height: 50vh">
      <sunburst class="py-3" :data="tree">

        <!-- Add behaviors -->
        <template slot-scope="{ on, actions }">
          <highlightOnHover v-bind="{ on, actions }"/>
          <zoomOnClick v-bind="{ on, actions }"/>
        </template>

        <!-- Add information to be displayed on top the graph -->
        <nodeInfoDisplayer slot="top" slot-scope="{ nodes }" :current="nodes.mouseOver" :root="nodes.root" description="" />

        <!-- Add bottom legend -->
        <breadcrumbTrail slot="legend" slot-scope="{ nodes, colorGetter, width }" :current="nodes.mouseOver" :root="nodes.root" :colorGetter="colorGetter" :from="nodes.clicked" :width="width" />

      </sunburst>
    </bs-card>
  </div>
</template>

<script>
import {
  breadcrumbTrail,
  highlightOnHover,
  nodeInfoDisplayer,
  sunburst,
  zoomOnClick
} from 'vue-d3-sunburst'
import 'vue-d3-sunburst/dist/vue-d3-sunburst.css'
import { mapState } from 'vuex'

export default {
  name: 'BudgetChart',
  components: {
    breadcrumbTrail,
    highlightOnHover,
    nodeInfoDisplayer,
    sunburst,
    zoomOnClick
  },
  computed: {
    ...mapState({
      budgets: state => state.budgetsStore
    }),
    tree () {
      const budgets = []
      this.budgets.forEach((b) => {
        budgets.push({
          name: b.label,
          size: b.amount
        })
      })
      const tree = {
        name: 'budget',
        children: budgets
      }
      return tree
    }
  }
}
</script>
